import { isMemberOfOrganization } from '../organization/isMemberOfOrganization';
import { isPremOrganizationAdmin } from '../organization/isPremOrganizationAdmin';
import { allowsSelfJoin } from './allowsSelfJoin';
import { isMemberTypeOfBoard } from './isMemberTypeOfBoard';

export const isEditableByOrganizationMember = (
  member: {
    id: string;
    idEnterprisesAdmin: Array<string>;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  },
  board: {
    prefs?: { isTemplate: boolean; selfJoin: boolean } | null;
    memberships: {
      id: string;
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
  },
  organization:
    | ({ id: string; offering: string } & {
        memberships: {
          id: string;
          deactivated: boolean;
          idMember: string;
          memberType: 'admin' | 'normal';
          unconfirmed: boolean;
        }[];
        enterprise?: {
          id?: string;
          idAdmins?: Array<string>;
        } | null;
      })
    | null,
): boolean => {
  if (!organization) {
    return false;
  }

  if (isMemberTypeOfBoard(member, board, organization, 'observer')) {
    return false;
  }

  const isOrgMember = isMemberOfOrganization(member, organization);
  return (
    isPremOrganizationAdmin(member, organization.id) ||
    (allowsSelfJoin(board) && isOrgMember)
  );
};
